
const state = {
    userInfo: {},
    shopInfo: {},

    imgForm: {
      legal_representative_card_front: '',
      legal_representative_card_backend: '',
      living_image: ''
    }, // 上传图片
}


export default state
